/* eslint-disable no-implicit-coercion */

import getBrowser from './lib/get-browser.js';
import MobileDetect from 'mobile-detect';

/**
 * store the oldie check value
 */
var oldBrowser;

export default function(configs) {
    // return cached browser if available
    if (oldBrowser !== undefined) { return oldBrowser; }

    var vs = {
            i: configs.ie,
            f: configs.firefox,
            c: configs.chrome,
            o: configs.opera,
            s: configs.safari,
            a: configs.android
        },
        browser = getBrowser(),
        doc = document.documentElement,
        mobileDetect = new MobileDetect(navigator.userAgent);

    oldBrowser = (browser.v < vs[browser.n]);

    // add the oldie class to the html element when we have an old browser
    if (oldBrowser) {
        doc.className += ' oldie';
    }

    // store the value in window.oldBrowser
    window.oldie = oldBrowser;

    // ===================================================================
    //                     browser detection helper
    // ===================================================================

    // add the user agent as data attribute
    doc.setAttribute('data-useragent', navigator.userAgent);

    // if the user in in an application (like facebook "in app browser")
    doc.setAttribute('data-app', browser.app);

    // add the browser abbreviation as data attribute
    doc.setAttribute('data-browser', browser.n);

    if (browser.n === 's') {
        // add the safari data attribute when its Safari
        doc.setAttribute('data-safari', browser.v);
    } else if (browser.n === 'i') {
        // add IE data attribute when we have one
        doc.setAttribute('data-ie', browser.v);
    } else if (browser.n === 'c') {
        // add Chrome data attribute when we have one
        doc.setAttribute('data-chrome', browser.v);
    } else if (browser.n === 'f') {
        // add FF data attribute when we have one
        doc.setAttribute('data-ff', browser.v);
    } else if (browser.n === 'o') {
        // add Opera data attribute when we have one
        doc.setAttribute('data-opera', browser.v);
    } else if (browser.n === 'a') {
        // add Android data attribute when we have one
        doc.setAttribute('data-android', browser.v);
    }

    doc.setAttribute('data-mobile', !!mobileDetect.mobile());
    doc.setAttribute('data-tablet', !!mobileDetect.tablet());

    return oldBrowser;
}



// WEBPACK FOOTER //
// ./~/@spinnwerk/old-browser-check/old-browser-check.js